/* The clinical notification strip (lab plan §6.3). Tokens only; danger for critical only. */

.strip {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
  padding: var(--space-2) var(--gutter);
  border-bottom: 1px solid var(--rule);
  background: var(--paper);
  color: var(--ink);
  font: var(--t-body);
}

.strip[data-danger] {
  border-top: 3px solid var(--danger);
  border-bottom: 3px solid var(--danger);
  color: var(--danger);
  font: var(--t-body-strong);
}

.message {
  flex: 1 1 24rem;
  min-width: 0;
  margin: 0;
}

.action {
  flex: none;
}
